import { createStore } from 'vuex'
import axiosInstance from '@/axiosInstance'
import getters from './getters'

const store = createStore({
  state: {
    user: null,
    isFetchingUser: false,
    roles: JSON.parse(localStorage.getItem('roles')) || [],
    permissions: JSON.parse(localStorage.getItem('permissions')) || [],
    accessToken: localStorage.getItem('access_token') || '',
    refreshToken: localStorage.getItem('refresh_token') || ''
  },
  mutations: {
    setUser(state, user) {
      state.user = user || null;
    },
    setAccessToken(state, token) {
      state.accessToken = token;
      localStorage.setItem('access_token', token);
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    setRefreshToken(state, token) {
      state.refreshToken = token;
      localStorage.setItem('refresh_token', token);
    },
    clearAuthData(state) {
      state.user = null;
      state.accessToken = '';
      state.refreshToken = '';
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      delete axiosInstance.defaults.headers.common['Authorization'];
    },
    setFetchingUser(state, isFetching) {
      state.isFetchingUser = isFetching;
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions || [];
      localStorage.setItem('permissions', JSON.stringify(permissions));
    },
  },
  actions: {
    async loginAction({ commit }, credentials) {
      try {
        const response = await axiosInstance.post('token/', credentials);

        const { access, refresh, user } = response.data || {};

        if (!access || !refresh) {
          throw new Error('Invalid token response');
        }

        commit('setAccessToken', access);
        commit('setRefreshToken', refresh);
        commit('setUser', user || null); // Safely handle missing user data

        await this.dispatch('fetchRolesAndPermissions');

      } catch (error) {
        console.error('Error during login:', error.response?.data?.detail || error.message);
        throw error;
      }
    },

    async fetchUser({ commit, state }) {
      if (state.user || state.isFetchingUser) return;
      commit('setFetchingUser', true);
      try {
        const response = await axiosInstance.get('my-info/', {
          headers: {
            Authorization: `Bearer ${state.accessToken}`
          }
        });
        commit('setUser', response.data);
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        commit('setFetchingUser', false);
      }
    },
    async fetchRolesAndPermissions({ commit, state }) {
      try {
        const response = await axiosInstance.get('staff-roles-permissions/', {
          headers: { Authorization: `Bearer ${state.accessToken}` }
        });
        commit('setRoles', response.data.roles);
        commit('setPermissions', response.data.permissions);
      } catch (error) {
        console.error('Error fetching roles and permissions:', error.response?.data?.detail || error.message);
      }
    },
    async logoutAction({ commit, state }) {
      try {
        await axiosInstance.post('logout/', {
          refresh_token: state.refreshToken
        });
      } catch (error) {
        console.error('Error during logout:', error);
      } finally {
        commit('clearAuthData');
      }
    }
  },
  getters
})

export default store
